export default __webpack_public_path__ + "static/media/Group 26976.d67224e1.svg";